import React from "react";

const ManualDrawerIcon = props => {
    const { fill } = props;

    return (
        <svg height="512" viewBox="0 0 426.496 426.496" width="512" xmlns="http://www.w3.org/2000/svg" fill={fill}><g><path d="m333.328 68.24h-239.504l-93.824 102.352v187.664h426.496v-187.664zm-232 17.056h224.464l77.632 85.296h-130.48c0 31.952-27.76 57.76-59.712 57.76s-59.712-25.808-59.712-57.76h-130.384z"></path></g></svg>
    );
}

export default ManualDrawerIcon;
